<template>
  <header class="header" :class="{ 'header-scrolled': scrollPosition > 50 }">
    <div class="container-fluid px-4">
      <nav class="navbar-custom">
        <router-link to="/" class="logo-link">
          <img src="/img/steeline-logo.png" alt="STEELINE Logo" class="logo-image" />
        </router-link>
        <button class="burger" @click="toggleMenu" :aria-expanded="isMenuOpen">
          <span :class="{ open: isMenuOpen }"></span>
          <span :class="{ open: isMenuOpen }"></span>
          <span :class="{ open: isMenuOpen }"></span>
        </button>
        <div class="nav-links" :class="{ open: isMenuOpen }">
          <button class="close-menu-btn" @click="closeMenu" aria-label="Закрыть меню">
            <i class="fas fa-times"></i>
          </button>
          <router-link to="/" class="nav-link" @click="closeMenu">Главная</router-link>
          <router-link to="/services" class="nav-link nav-link-premium" @click="closeMenu">Возможности</router-link>
          <router-link to="/equipment" class="nav-link" @click="closeMenu">Оборудование</router-link>
          <router-link to="/products" class="nav-link" @click="closeMenu">Продукция</router-link>
          <router-link to="/contacts" class="nav-link" @click="closeMenu">Контакты</router-link>
          <div class="header-contacts">
            <a href="tel:+79677700773" class="contact-btn">
              <i class="fas fa-phone-alt"></i> +7 967 770 07 73
            </a>
            <a href="mailto:info@steeline.ru" class="contact-btn btn-mail">
              <i class="fas fa-envelope"></i>
            </a>
          </div>
        </div>
      </nav>
    </div>
    <div v-if="isMenuOpen" class="menu-backdrop" @click="closeMenu"></div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  data() {
    return {
      isMenuOpen: false,
      scrollPosition: 0
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      if (this.isMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    closeMenu() {
      this.isMenuOpen = false
      document.body.style.overflow = ''
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
    }
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.updateScroll)
  },
  watch: {
    '$route'() {
      this.closeMenu()
    }
  }
}
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  width: 100%;
  background: rgba(255,255,255,0.92);
  box-shadow: 0 4px 24px rgba(0,0,0,0.06);
  z-index: 1000;
  transition: background 0.4s ease, box-shadow 0.3s, border-bottom 0.4s ease;
  padding: 0;
  border-bottom: 1px solid transparent;
}
.header * {
  transition: color 0.3s ease, background 0.3s ease, border-color 0.3s ease;
}
.header-scrolled {
  background: rgba(255,255,255,0.98);
  box-shadow: 0 8px 30px rgba(0,0,0,0.10);
}
.container-fluid {
  max-width: 1440px;
  margin: 0 auto;
}
.navbar-custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 72px;
  padding: 10px 0;
}
.logo-link {
  display: flex;
  align-items: center;
  min-width: 120px;
}
.logo-image {
  height: 48px;
  width: auto;
  max-width: 160px;
  object-fit: contain;
  transition: height 0.3s;
}
.burger {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1201;
}
.burger span {
  display: block;
  width: 26px;
  height: 3px;
  margin: 4px 0;
  background: #1a3869;
  border-radius: 2px;
  transition: 0.4s;
}
.burger span.open:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.burger span.open:nth-child(2) {
  opacity: 0;
}
.burger span.open:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}
.nav-links {
  display: flex;
  align-items: center;
  gap: 24px;
  transition: right 0.3s;
  position: relative;
}
.nav-link {
  font-size: 1.08rem;
  font-weight: 500;
  color: #1a3869;
  padding: 8px 14px;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
  text-decoration: none;
}
.nav-link:hover, .nav-link.router-link-active {
  background: #e8f0fe;
  color: #1967d2;
}

/* Premium link styling */
.nav-link-premium {
  position: relative;
  background: linear-gradient(135deg, rgba(25, 118, 178, 0.08) 0%, rgba(10, 77, 119, 0.05) 100%);
  border: 1px solid rgba(25, 118, 178, 0.15);
  font-weight: 600;
}

.nav-link-premium::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent 0%, var(--primary-light) 50%, transparent 100%);
  transition: width 0.3s;
}

.nav-link-premium:hover::before,
.nav-link-premium.router-link-active::before {
  width: 80%;
}

.nav-link-premium:hover,
.nav-link-premium.router-link-active {
  background: linear-gradient(135deg, rgba(25, 118, 178, 0.15) 0%, rgba(10, 77, 119, 0.1) 100%);
  border-color: rgba(25, 118, 178, 0.25);
  color: #1967d2;
}
.header-contacts {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-left: 24px;
}
.contact-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 1rem;
  font-weight: 500;
  background: #e8f0fe;
  color: #1967d2;
  border: none;
  border-radius: 6px;
  padding: 7px 16px;
  text-decoration: none;
  transition: background 0.2s, color 0.2s;
}
.contact-btn.btn-mail {
  background: #1967d2;
  color: #fff;
}
.contact-btn:hover {
  background: #d2e3fc;
  color: #124a8d;
}
.contact-btn.btn-mail:hover {
  background: #124a8d;
  color: #fff;
}
.close-menu-btn {
  display: none;
  position: absolute;
  top: 15px;
  right: 15px;
  width: 40px;
  height: 40px;
  background: rgba(248, 249, 250, 0.9);
  border: 1px solid #e8f0fe;
  border-radius: 50%;
  font-size: 22px;
  color: #1a3869;
  cursor: pointer;
  z-index: 1203;
  align-items: center;
  justify-content: center;
}
.menu-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.15);
  z-index: 1200;
}
@media (max-width: 991.98px) {
  .navbar-custom {
    min-height: 60px;
    padding: 6px 0;
  }
  .nav-links {
    position: fixed;
    top: 0;
    right: -100vw;
    height: 100vh;
    width: 85vw;
    max-width: 340px;
    background: #fff;
    box-shadow: -4px 0 24px rgba(0,0,0,0.12);
    flex-direction: column;
    align-items: center;
    padding: 70px 24px 24px 24px;
    gap: 18px;
    transition: right 0.3s;
    z-index: 1202;
    overflow-y: auto;
  }
  .nav-links.open {
    right: 0;
  }
  .close-menu-btn {
    display: flex;
  }
  .burger {
    display: flex;
  }
  .nav-link {
    width: 100%;
    text-align: center;
    padding: 12px 16px;
  }
  
  .nav-link-premium {
    margin: 0 0 10px 0;
  }
  .header-contacts {
    flex-direction: column;
    align-items: center;
    gap: 14px;
    margin-left: 0;
    margin-top: 24px;
    width: 100%;
    padding-top: 24px;
    border-top: 1px solid #e8f0fe;
  }
  .contact-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Dark Mode for Services Page */
.header-dark-mode {
  background: linear-gradient(135deg, rgba(10, 13, 26, 0.98) 0%, rgba(15, 20, 32, 0.98) 100%) !important;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(25, 118, 178, 0.25) !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;
}

.header-dark-mode .logo {
  color: #fff !important;
}

.header-dark-mode .logo-image {
  filter: brightness(0) invert(1);
}

.header-dark-mode .burger span {
  background: rgba(255, 255, 255, 0.9) !important;
}

.header-dark-mode .nav-link {
  color: rgba(255, 255, 255, 0.8) !important;
}

.header-dark-mode .nav-link:hover,
.header-dark-mode .nav-link.router-link-active {
  background: rgba(25, 118, 178, 0.2) !important;
  color: #1976b2 !important;
}

.header-dark-mode .nav-link-premium {
  background: linear-gradient(135deg, rgba(25, 118, 178, 0.25) 0%, rgba(10, 77, 119, 0.2) 100%) !important;
  border-color: rgba(25, 118, 178, 0.4) !important;
  color: #1976b2 !important;
}

.header-dark-mode .nav-link-premium:hover,
.header-dark-mode .nav-link-premium.router-link-active {
  background: linear-gradient(135deg, rgba(25, 118, 178, 0.35) 0%, rgba(10, 77, 119, 0.25) 100%) !important;
  border-color: rgba(25, 118, 178, 0.6) !important;
  color: #42a5f5 !important;
}

.header-dark-mode .nav-link-premium::before {
  background: linear-gradient(90deg, transparent 0%, #1976b2 50%, transparent 100%) !important;
}

.header-dark-mode .contact-btn {
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: rgba(25, 118, 178, 0.35) !important;
}

.header-dark-mode .contact-btn:hover {
  background: rgba(25, 118, 178, 0.2) !important;
  color: #1976b2 !important;
  border-color: #1976b2 !important;
}

.header-dark-mode .contact-btn i {
  color: #1976b2 !important;
}

@media (max-width: 575.98px) {
  .logo-image {
    height: 36px;
    max-width: 110px;
  }
  .nav-links {
    width: 100vw;
    max-width: 100vw;
    padding: 35px 20px 20px 20px;
    align-items: center;
  }
  .nav-link {
    font-size: 1.1rem;
    padding: 14px 16px;
  }
}

</style>
